module.exports = __webpack_public_path__ + "img/bg.1a5e2e70.png";